import { useContext, useState } from "react";
import { Alert, Button, Form, Input } from "antd";
import { makeApiRequest } from "../../../lib/api";
import { TypeParams } from "../../../types";
import { GlobalStateContext } from "../../../lib/GlobalContext";
import Link from "antd/es/typography/Link";
import { useTranslation } from "react-i18next"; // Import useTranslation

interface EgwAuthenticationForm1LoginProps {
  params: TypeParams;
}

const EgwAuthenticationForm1Login: React.FC<EgwAuthenticationForm1LoginProps> = ({ params }) => {
  const { t } = useTranslation(); // Initialize useTranslation
  const [error, setError] = useState("");
  const [form] = Form.useForm();
  const { setState, navigate } = useContext(GlobalStateContext);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onFinishForm = async () => {
    // console.log("SUBMITT");

    const email = form.getFieldValue("email");
    if (!email) {
      setError(t("kundenbereich.login.no_email"));
      return;
    }

    const clientnumber = form.getFieldValue("clientnumber");
    if (!clientnumber) {
      setError(t("kundenbereich.login.no_clientnumber"));
      return;
    }

    setError("");
    setIsSubmitting(true); // Set loading state

    try {
      const content: any = {
        customer_number: clientnumber,
        customer_email: email,
      };
      const action = "REACT_CUSTOMER_VALIDATION";
      const response = (await makeApiRequest(params, action, content)) as any;
      const parsed = JSON.parse(response);
      if (!parsed || parsed.STATUS !== "OK") {
        setError(t("kundenbereich.login.error"));
      } else {
        if (parsed.MESSAGE !== "OK") {
          setError(t("kundenbereich.login.unsuccessful"));
          setState((prevState: any) => ({ ...prevState, user: undefined, isAuthenticated: false }));
        } else {
          setState((prevState: any) => ({ ...prevState, user: parsed.CONTENT, isAuthenticated: true }));
        }
      }
    } catch (error) {
      setError(t("kundenbereich.login.error"));
    } finally {
      setIsSubmitting(false); // Reset loading state
    }
  };

  const onFinishFailed = async () => {
    setError(t("kundenbereich.login.incomplete_form"));
  };

  return (
    <>
      {error && <Alert message={error} />}

      <p>{t("kundenbereich.login.intro")}</p>

      <div className={"my-lg"}>
        <Form
          name="login"
          form={form}
          wrapperCol={{ span: 16 }}
          onFinish={onFinishForm}
          onFinishFailed={onFinishFailed}
          style={{ maxWidth: 600 }}
          autoComplete="off"
        >
          <Form.Item
            label={t("kundenbereich.login.email_label")}
            name="email"
            rules={[
              { required: true, message: t("kundenbereich.login.email_required") },
              { type: "email", message: t("kundenbereich.login.email_invalid") },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={t("kundenbereich.login.clientnumber_label")}
            name="clientnumber"
            rules={[{ required: true, message: t("kundenbereich.login.clientnumber_required") }]}
          >
            <Input />
          </Form.Item>
          <p>
            {t("kundenbereich.login.clientnumber_info")}{" "}
            <Link onClick={(e) => navigate(params, "clientnumber")}>{t("kundenbereich.login.clientnumber_link")}</Link>
          </p>

          <Form.Item wrapperCol={{ offset: 20, span: 16 }}>
            <Button type="primary" htmlType="submit" loading={isSubmitting}>
              {t("kundenbereich.login.submit")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default EgwAuthenticationForm1Login;
